import { useStateSelector } from '../store/selectors';
import { TimelineParty } from '../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { USER_ROLES } from '../utils/constants';

export const useCurrentMarketplaceParty = (engagementId?: number): TimelineParty => {
    const summary = useStateSelector((s) => s.userSummary.summary);

    if (engagementId && summary?.engagements) {
        const engagement = summary.engagements.find((e: any) => e.id === engagementId);
        if (engagement && engagement.party !== undefined) {
            return engagement.party;
        }
    }

    if (summary?.isMarketplaceBuyer) {
        return TimelineParty.Buyer;
    }
    if (summary?.roleId === USER_ROLES.ADMIN) {
        return TimelineParty.VetValue;
    }
    if (summary?.isMarketplaceBroker) {
        return TimelineParty.Broker;
    }
    return TimelineParty.Seller;
};
